import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Development } from "@models/development.model";
import { Project } from "@models/project.model";
import { DevelopmentService } from "@services/development.service";
import { EmailService } from "@services/email.service";
import { ProjectService } from "@services/project.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  // @Input() projectId = "";
  // @Input() developmentName = "";
  @Output() closeModal = new EventEmitter<boolean>();

  projectId = "";

  isDropdownDisabled = false;

  isModal = false;
  isValid = true;

  developmentList: Development[] = [];
  filteredProjectList: Project[] = [];
  developmentId = 0;
  developmentName = "";

  requestURL = "https://my.nycha.info/PublicSite/CPD/SendEmail";
  payload = {
    email: {
      EbuilderId: "",
      FirstName: "",
      LastName: "",
      Phone: "",
      Email: "",
      Message: "",
      EmailType: "ProjectInquiry",
      SelectedDevelopment: "",
      SelectedProject: "",
      projectDescription: "",
      projectManager: "",
    },
  };

  constructor(
    public activatedRoute: ActivatedRoute,
    public projectService: ProjectService,
    public developmentService: DevelopmentService,
    public emailService: EmailService,
  ) {}

  ngOnInit(): void {
    const data = this.activatedRoute.snapshot.data["contactData"];
    try {
      const link = document.querySelector(".language-selector a") as HTMLAnchorElement;
      if (link) {
        link.href = `${window.location}#`;
      }
    } catch (error) {
      console.log(error);
    }

    this.developmentList = this.developmentService
      .getItems()
      .sort((a, b) => a.name.localeCompare(b.name));

    if (!this.projectId) {
      this.projectId = data.selectedProject;
      this.developmentName = data.selectedDevelopment;
    } else {
      this.isModal = true;
    }

    if (this.developmentName != "") {
      this.payload.email.EbuilderId = this.projectId;
      this.payload.email.SelectedProject = this.projectId;
      this.payload.email.SelectedDevelopment = this.developmentName;
      this.developmentId = this.projectService.getProjectById(this.projectId)?.developmentId || 0;
      this.filteredProjectList = this.projectService.getProjectsByDevelopmentId(this.developmentId);
      const project = this.projectService.getProjectById(this.projectId);
      this.payload.email.projectDescription = project?.name ?? "";
      this.payload.email.projectManager = project?.manager ?? "";
    }

    if (screen.width < 500) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  updateEmailType(event: any): void {
    this.payload.email.EmailType = event.target.value;
    if (event.target.value == "TechnicalDifficulties" || event.target.value == "GeneralInquiry") {
      this.isDropdownDisabled = true;
      this.developmentName = "";
      this.developmentId = 0;
      this.payload.email.SelectedProject = "";
      this.payload.email.SelectedDevelopment = "";
      this.payload.email.EbuilderId = "";
      this.updateFilteredList("");
    } else {
      this.isDropdownDisabled = false;
      this.payload.email.SelectedProject = this.projectId;
      this.payload.email.EbuilderId = this.projectId;
      this.payload.email.SelectedDevelopment = this.developmentName;
    }
  }

  selectProject(event: any): void {
    this.projectId = event.target.value;

    // if technical dificulties is picked, then no EbuilderId should be sent
    if (
      this.payload.email.EmailType !== "TechnicalDifficulties" &&
      this.payload.email.EmailType !== "GeneralInquiry"
    ) {
      this.payload.email.EbuilderId = this.projectId;
    } else {
      this.payload.email.EbuilderId = "";
    }

    if (event !== undefined && event !== "") {
      const project = this.projectService.getProjectById(event.target.value);
      this.payload.email.projectDescription = project?.name ?? "";
      this.payload.email.projectManager = project?.manager ?? "";
    } else {
      this.payload.email.projectDescription = "";
      this.payload.email.projectManager = "";
    }
    this.payload.email.SelectedProject = this.projectId;
  }

  updateFilteredList(event: any): void {
    this.projectId = "";
    if (event !== undefined && event !== "") {
      this.payload.email.SelectedDevelopment =
        this.developmentList.find((d) => d.id == event.target.value)?.name ?? "";
      this.filteredProjectList = this.projectService.getProjectsByDevelopmentId(event.target.value);
    } else {
      this.payload.email.SelectedDevelopment = "";
    }

    // console.log(event.target.value);
  }

  sendPost1(): void {
    if (
      this.payload.email.FirstName != "" &&
      this.payload.email.LastName != "" &&
      this.payload.email.Email != "" &&
      this.payload.email.Message.trim() != ""
    ) {
      const hostURL = environment.hostURL.substring(0, environment.hostURL.length - 1);

      fetch(this.requestURL, {
        method: "post",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        referrer: `${hostURL}?EBuilderProjectId=${this.projectId}`,
        referrerPolicy: "strict-origin-when-cross-origin",
        body: JSON.stringify(this.payload),
      })
        .then((res) => {
          console.log("res", res);

          return res.json();
        })
        .then((data) => {
          console.log("Request succeeded with JSON response", data);
          this.closeModal.emit(true);
          alert("Your email was sent successfully.");
        })
        .catch((error: Error) => {
          console.error("Request failed", error);
        });
    } else {
      this.isValid = false;
    }
  }

  generateRandomString(length = 5): string {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

  formatPhoneNumber(event: any): void {
    let input = event.target.value.replace(/\D/g, '');

    if (input.length > 3 && input.length <= 6) {
      input = `(${input.slice(0, 3)})-${input.slice(3)}`;
    } else if (input.length > 6) {
      input = `(${input.slice(0, 3)})-${input.slice(3, 6)}-${input.slice(6, 10)}`;
    } else if (input.length > 0) {
      input = `(${input.slice(0, 3)})${input.slice(3)}`;
    }
    this.payload.email.Phone = input;
  }
  
  restrictNonNumeric(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) { // Allow only numbers (0-9)
      event.preventDefault(); 
    }
  }  

  sendPost(): void {
    if (
      this.payload.email.FirstName != "" &&
      this.payload.email.LastName != "" &&
      this.payload.email.Email != "" &&
      this.payload.email.Message.trim() != ""
    ) {
      const subjectLine = this.payload.email.SelectedProject
        ? `Project: ${this.payload.email.SelectedProject} - `
        : "";

      const emailData = {
        inquiryType: this.getInquiryType(),
        subject: `Capital Projects Tracker Inquiry  (${subjectLine}InquiryId: ${this.generateRandomString()})`,
        recipientName: "NYCHA Team",
        messageDetail: this.payload.email.Message.trim(),
        inquirerName: `${this.payload.email.FirstName} ${this.payload.email.LastName}`,
        inquirerEmail: `${this.payload.email.Email}`,
        inquirerPhone: `${this.payload.email.Phone}`,
        developmentName: `${this.payload.email.SelectedDevelopment}`,
        projectId: `${this.payload.email.SelectedProject}`,
        projectDescription: this.payload.email.projectDescription
          ? ` - ${this.payload.email.projectDescription}`
          : "",
        projectManager: `${this.payload.email.projectManager}`,
        htmlBody: "",
      };

      // First get the email template
      this.emailService.getEmailTemplate(emailData).subscribe((htmlTemplate) => {
        emailData.htmlBody = htmlTemplate;

        // Then send the email with the generated template
        this.emailService.sendEmail(emailData).subscribe(
          (response) => {
            console.log("Email sent successfully:", response);
            alert(`Email sent successfully. Thank you for your inquiry!`);
            this.closeModal.emit(true);
            },
          (error) => {
            console.error("Error sending email:", error?.message || error);
          },
        );
      });
    } else {
      alert(`Please complete all mandatory fields and click "Submit."`);
    }
  }

  private getInquiryType() {
    let inquiryType = "Project Inquiry";
    switch (this.payload.email.EmailType) {
      case "TechnicalDifficulties":
        inquiryType = "Technical Difficulties";
        break;
      case "GeneralInquiry":
        inquiryType = "General Inquiry";
        break;
      case "ProjectInquiry":
        inquiryType = "Project Inquiry";
        break;
    }
    return inquiryType;
  }
}
